<ng-container cdkScrollable *transloco="let t">
    <div #headerStart>
        @if (selectedProviders.length > 0) {
        <mat-card
            appearance="outlined"
            class="providers-results"
            fxLayoutAlign="center"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="space-between"
                fxLayoutAlign.xs="center"
                fxLayoutAlign.sm="center"
                fxLayout.xs="column"
                fxLayout.sm="column"
                fxFlex.xs="90%"
                fxFlex.sm="90%"
                fxFlexFill
            >
                <mat-chip-listbox class="provider-chips">
                    @for ( provider of selectedProviders; track provider; let i
                    = $index) {
                    <mat-chip-option
                        class="provider-chip"
                        removable="true"
                        (removed)="removeProvider(i)"
                    >
                        <span class="provider-chip-text">{{
                            provider.name
                        }}</span>
                        <mat-icon class="provider-chip-remove" matChipRemove
                            >cancel</mat-icon
                        >
                    </mat-chip-option>
                    }
                </mat-chip-listbox>
                <button
                    class="provider-start-application"
                    mat-flat-button
                    (click)="startApplication()"
                    id="start-application-button-header"
                >
                    {{ t("provider.start-application") }} ({{
                        selectedProviders.length
                    }})
                </button>
            </div>
        </mat-card>
        }
    </div>

    @if (providers?.length) {
    <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="results-top"
    >
        <p>
            {{ t("provider.showing") }}:
            {{ filtered ? "" : t("provider.all") }} {{ providers?.length }}
            {{ filtered ? t("provider.filtered") : "" }}
            {{ t("provider.providers") }}
        </p>
        <button mat-button [matMenuTriggerFor]="sortMenu">
            <span class="sort-icon"
                >{{ t("provider.sort-by") + ": " + sortOrderText | uppercase }}
                <mat-icon>expand_more</mat-icon></span
            >
        </button>
        <mat-menu #sortMenu="matMenu">
            <button
                mat-menu-item
                value="name"
                (click)="
                    setSortOrder(
                        'name',
                        t('provider.sort-by-options.name-a-to-z')
                    )
                "
            >
                {{ t("provider.sort-by-options.name-a-to-z") }}
            </button>
            <button
                mat-menu-item
                value="-name"
                (click)="
                    setSortOrder(
                        '-name',
                        t('provider.sort-by-options.name-z-to-a')
                    )
                "
            >
                {{ t("provider.sort-by-options.name-z-to-a") }}
            </button>
            <button
                mat-menu-item
                value="distance"
                (click)="
                    setSortOrder(
                        'distance',
                        t('provider.sort-by-options.distance')
                    )
                "
            >
                {{ t("provider.sort-by-options.distance") }}
            </button>
        </mat-menu>
    </div>
    @if (loading) {
    <mat-spinner
        style="margin-left: auto; margin-right: auto; margin-bottom: 1rem"
    ></mat-spinner>
    }
    <div
        fxLayout="row wrap"
        fxLayoutAlign="start space-between"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="start"
        fxLayoutGap.sm="30px"
        class="results-list"
    >
        @for (provider of providers; track provider) {
        <app-provider-card
            [provider]="provider"
            (selectedEvent)="selectProvider($event)"
        >
        </app-provider-card>
        }
    </div>
    } @else {
    <div fxLayout="column" fxLayoutAlign="center center" class="no-results">
        <img
            class="no-results"
            src="assets/img/provider-icons/no-results.svg"
        />
        <h2>{{ t("provider.no-results.header") }}</h2>
        <p [innerHTML]="t('provider.no-results.description')"></p>
    </div>
    }

    <div #fixedStart>
        @if (selectedProviders.length > 0) {
        <mat-card
            appearance="outlined"
            class="providers-results"
            fxLayoutAlign="center"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="space-between"
                fxLayoutAlign.xs="center"
                fxLayoutAlign.sm="center"
                fxLayout.xs="column"
                fxLayout.sm="column"
                fxFlex.xs="90%"
                fxFlex.sm="90%"
                fxFlexFill
            >
                <mat-chip-listbox class="provider-chips">
                    @for ( provider of selectedProviders; track provider; let i
                    = $index) {
                    <mat-chip-option
                        class="provider-chip"
                        removable="true"
                        (removed)="removeProvider(i)"
                    >
                        <span class="provider-chip-text">{{
                            provider.name
                        }}</span>
                        <mat-icon class="provider-chip-remove" matChipRemove
                            >cancel</mat-icon
                        >
                    </mat-chip-option>
                    }
                </mat-chip-listbox>
                <button
                    class="provider-start-application"
                    mat-flat-button
                    (click)="startApplication()"
                    id="start-application-button-fixed"
                >
                    {{ t("provider.start-application") }} ({{
                        selectedProviders.length
                    }})
                </button>
            </div>
        </mat-card>
        }
    </div>

    <div #footerStart>
        @if (selectedProviders.length > 0) {
        <mat-card
            appearance="outlined"
            class="providers-results"
            fxLayoutAlign="center"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="space-between"
                fxLayoutAlign.xs="center"
                fxLayoutAlign.sm="center"
                fxLayout.xs="column"
                fxLayout.sm="column"
                fxFlex.xs="90%"
                fxFlex.sm="90%"
                fxFlexFill
            >
                <mat-chip-listbox class="provider-chips">
                    @for ( provider of selectedProviders; track provider; let i
                    = $index) {
                    <mat-chip-option
                        class="provider-chip"
                        removable="true"
                        (removed)="removeProvider(i)"
                    >
                        <span class="provider-chip-text">{{
                            provider.name
                        }}</span>
                        <mat-icon class="provider-chip-remove" matChipRemove
                            >cancel</mat-icon
                        >
                    </mat-chip-option>
                    }
                </mat-chip-listbox>
                <button
                    class="provider-start-application"
                    mat-flat-button
                    (click)="startApplication()"
                    id="start-application-button-footer"
                >
                    {{ t("provider.start-application") }} ({{
                        selectedProviders.length
                    }})
                </button>
            </div>
        </mat-card>
        }
    </div>
</ng-container>
